export default __webpack_public_path__ + "media/images/images/flags/tn-ff026c25477e453795ad36f1358158b9.png";